import { Component, ViewEncapsulation } from '@angular/core';
import { SuiviSaisieService } from './suivi-saisie.service';


@Component({
  selector: 'bis-suivi-saisie',
  templateUrl: './suivi-saisie.component.html',
  styleUrls: ['./suivi-saisie.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SuiviSaisieComponent {
  constructor(public suiviSaisieService: SuiviSaisieService) { }
}
